import { useLocation, Navigate } from "react-router-dom";
import { useAtom } from "jotai";
import {
  loggedInUser,
  isOwnerPackage,
  accountType,
  subscribedPackage,
} from "../utils/store";
import { useNavigate } from "react-router-dom";

const CheckSubscriptionExpiry = () => {
  const navigate = useNavigate();

  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [isOwnerPackageActive, setIsOwnerPackageActive] =
    useAtom(isOwnerPackage);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const [personalAccount, setPersonalAccount] = useAtom(accountType);
  const location = useLocation();

  let isPersonalPackage = loggedUser?.package_details?.filter(
    (obj) => obj.team_id === null
  );
  //   if (isPersonalPackage.length > 0) {
  //     let endDate = new Date(isPersonalPackage?.[0]?.end_date);
  //     let startDate = new Date();
  //     if (
  //       (Object.keys(purchasedPackage).length > 0 &&
  //         isPersonalPackage?.length <= 0) ||
  //       startDate >= endDate
  //     ) {
  //       if (
  //         personalAccount &&
  //         Object.keys(purchasedPackage).length > 0 &&
  //         purchasedPackage.package_name != "Starter"
  //       ) {
  //         navigate("/paymentNotPaid");
  //       }
  //     } else {
  //       navigate("");
  //     }
  //   } else {
  //     console.log("paymentNotPaid");

  //     navigate("/paymentNotPaid");
  //   }

  if (Object.keys(purchasedPackage).length > 0) {
  }

  return Object.keys(purchasedPackage).length > 0 &&
    loggedUser?.role?.includes("customer") &&
    personalAccount &&
    purchasedPackage.package_name !== "Starter" ? (
    <Navigate to="/paymentNotPaid" state={{ from: location }} replace />
  ) : loggedUser?.id ? (
    ""
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default CheckSubscriptionExpiry;
